// Module
var code = "<span class=\"tag\"> <ng-transclude></ng-transclude> </span>";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Components/Tag/Tag.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;